import Request, { Methods } from '@libraries/request/'

export default class Locale extends Request {
  constructor(locale, apiKey) {
    super()
    this.locale = locale
    this.apiKey = apiKey
  }

  get path() {
    return '/locale'
  }

  get method() {
    return Methods.post
  }

  get parameters() {
    const params = {}
    params.locale = this.locale
    params.api_key = this.apiKey
    return params
  }

  decode({ data }) {
    return data
  }

  decodeError(error) {
    return { error: error }
  }
}
